import { useState, useEffect, useRef } from "react";
import { json, useLocation, useNavigate } from "react-router-dom";

import TopBarLayout from "./TopBarLayout";
import ContentLayout from "./ContentLayout";
import Toast from "./Toast";
import { apiContext, apiDict, getMediaUrl } from "../context/api-v1/api";
import { checkMobile } from "../utils/utils";

import {
  Box,
  Typography,
  Grid,
  TextField,
  Chip,
  Button,
  Input,
  IconButton,
  Container,
  Card,
  CardMedia,
  CardContent,
  TextareaAutosize,
  Dialog,
  Checkbox,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";

export default function ArticleEdit({ state }) {
  // 编辑功能组件
  let articleDatas,
    backupInputArticleDatas = useRef({}),
    nextUrl = "/",
    currentCategory,
    currentArticleUrl,
    currentArticle = {};


  const articleDatas_ = localStorage.getItem("articleDatas");
  if (state) {
    articleDatas = state.articleDatas;
    backupInputArticleDatas.current = { ...articleDatas };
    nextUrl = state.next;
    if (articleDatas.category) {
      currentCategory = articleDatas.category.id;
    }

    currentArticleUrl = articleDatas.target;
    currentArticle = {
      categoryID: currentCategory,
      title: articleDatas.title,
      description: articleDatas.description,
      tags:
        typeof articleDatas.tags[0] === "object" // 2025-09-05 14:16:56 兼容tags id数组和对象数组的情况
          ? articleDatas.tags.map((v) => v.content)
          : articleDatas.tags,
      content: articleDatas.body,
      avatar_id: articleDatas.avatar.id,
      is_private: articleDatas.is_private,
    };
  } else if (articleDatas_) {
    const articleDatasOld = JSON.parse(articleDatas_);

    const currentArticleDatas = {};
    const currentArticle_ = {};
    if (articleDatasOld.title) {
      currentArticleDatas.title = articleDatasOld.title;
      currentArticle_.title = articleDatasOld.title;
    }
    if (articleDatasOld.tags) {
      currentArticleDatas.tags = articleDatasOld.tags;
      currentArticle_.tags = articleDatasOld.tags;
    }
    if (articleDatasOld.description) {
      currentArticleDatas.description = articleDatasOld.description;
      currentArticle_.description = articleDatasOld.description;
    }
    if (articleDatasOld.body) {
      currentArticleDatas.body = articleDatasOld.body;
      currentArticle_.content = articleDatasOld.body;
    }

    currentArticleDatas.is_private = articleDatasOld.is_private;
    currentArticle_.is_private = articleDatasOld.is_private;

    if (articleDatasOld.avatar_content) {
      currentArticleDatas.avatar = {
        content: articleDatasOld.avatar_content,
        id: articleDatasOld.avatar_id,
      };
      currentArticle_.avatar_id = articleDatasOld.avatar_id;
      currentArticle_.avatar_content = articleDatasOld.avatar_content;
    }

    if (articleDatasOld.categoryID) {
      currentCategory = articleDatasOld.categoryID;
      currentArticle_.categoryID = articleDatasOld.categoryID;
    }

    if (currentArticleDatas) {
      articleDatas = { ...currentArticleDatas };
    }

    if (currentArticle_) {
      currentArticle = { ...currentArticle_ };
    }
  }

  const [categoryDatas, setCategoryDatas] = useState();
  const [addCategoryID, setAddCategoryID] = useState(currentCategory);
  const [addCategory, setAddCategory] = useState();

  const [statusCode, setStatusCode] = useState();
  const [newArticleDatas, setNewArticleDatas] = useState();

  const [imgStatusCode, setImgStatusCode] = useState();
  const [currentImgDatas, setCurrentImgDatas] = useState();

  // const [tokenStatusCode, setTokenStatusCode] = useState();
  // const [tokenDatas, setTokenDatas] = useState();

  const [contentImgStatusCode, setContentImgStatusCode] = useState();
  const [contentImgDatas, setContentImgDatas] = useState();

  const [newCategotyStatusCode, setNewCategotyStatusCode] = useState();
  const [newCategotyDatas, setNewCategotyDatas] = useState();

  const navigate = useNavigate();
  const tagRef = useRef({ article: { ...currentArticle } });
  const imgRef = useRef();
  const imgShowRef = useRef();
  const contentImgRef = useRef({ flag: false });
  const articleSaveRef = useRef({ flag: false });
  const intervalSaveRef = useRef({ flag: false });
  const newCategoryRef = useRef({ content: "" });
  const editorRef = useRef({flag:false})

  const [msgBoxShow, setMsgBoxShow] = useState(false);
  const [dialogShow, setDialogShow] = useState(false);
  const [msgTips, setMsgTips] = useState({});
  const [flushFlag, setFlushFlag] = useState(false);

  const textareaNode = document.getElementsByClassName(
    "editormd-markdown-textarea"
  )[0];

  const is_phone = checkMobile();

  // useEffect(() => {  // 2025-09-05 16:17:19 注释掉自动刷新token功能, 采用更标准的refresh刷新逻辑
  //   const refresh = localStorage.getItem("refresh");
  //   apiContext(apiDict.refreshToken, "GET", setTokenDatas, setTokenStatusCode);
  // }, []);

  useEffect(() => {
    apiContext(
      apiDict.category,
      "GET",
      setCategoryDatas,
      "",
      "",
      "",
      {
        next: window.location.pathname,
        articleDatas: state ? state.articleDatas : undefined,
      },
      setMsgBoxShow,
      setMsgTips
    );
  }, []);

  useEffect(() => {
    if (statusCode === 401) {
      setMsgBoxShow(true);
      setMsgTips({ status: "warning", msg: "登录失效" });

      setTimeout(() => {
        navigate("/user/login/");
      }, 1000);
    } else if (statusCode === 201) {
      setMsgBoxShow(true);
      setMsgTips({ status: "success", msg: "文章新建成功" });
      setTimeout(() => {
        localStorage.removeItem("articleDatas");
        navigate("/blogs?blogID=" + newArticleDatas.id);
      }, 1000);
    } else if (statusCode === 200) {
      if (intervalSaveRef.current.flag) {
        intervalSaveRef.current.flag = false;
        return;
      }

      const flag = articleSaveRef.current.flag;
      setMsgBoxShow(true);
      if (flag) {
        setMsgTips({ status: "success", msg: "文章保存成功" });
      } else {
        setMsgTips({ status: "success", msg: "文章修改成功" });
        setTimeout(() => {
          navigate(nextUrl);
        }, 1000);
      }
    }
  }, [newArticleDatas]);

  useEffect(() => {
    if (imgStatusCode === 401) {
      setMsgBoxShow(true);
      setMsgTips({ status: "warning", msg: "登录失效" });

      setTimeout(() => {
        navigate("/user/login/");
      }, 1000);
    } else if (imgStatusCode === 201) {
      setMsgBoxShow(true);
      setMsgTips({ status: "success", msg: "标题图上传成功" });
    } else if (imgStatusCode === 200) {
      setMsgBoxShow(true);
      setMsgTips({ status: "success", msg: "标题图修改成功" });
    } else if (imgStatusCode === 400) {
      setMsgBoxShow(true);
      setMsgTips({ status: "error", msg: "标题图上传失败" });
    }
  }, [currentImgDatas]);

  // useEffect(() => {
  //   if (tokenStatusCode === 401 || tokenStatusCode === 400) {
  //     setMsgBoxShow(true);
  //     setMsgTips({ status: "warning", msg: "登录失效" });
  //     setTimeout(() => {
  //       navigate("/user/login/", {
  //         state: {
  //           next: window.location.pathname,
  //           articleDatas: state ? state.articleDatas : undefined,
  //         },
  //       });
  //     }, 1000);
  //   } else if (tokenStatusCode === 200) {
  //     setMsgBoxShow(true);
  //     if (!state && articleDatas_) {
  //       setMsgTips({ status: "success", msg: "继续历史编辑" });
  //     } else {
  //       setMsgTips({ status: "success", msg: "用户状态刷新成功" });
  //     }
  //     localStorage.setItem("access", tokenDatas.access);
  //   }
  // }, [tokenDatas]);

  useEffect(() => {
    if (!editorRef.current.flag ) {
      if (is_phone) {
        editorRef.current.editor = window.editormd("editor", {
          width: "100%",
          height: "100vh",
          watch: false,
          toolbar: false,
          // markdown: "xxxx",     // dynamic set Markdown text
          path: "/static/editor.md/lib/", // Autoload modules mode, codemirror, marked... dependents libs path
        });;
      } else {
        editorRef.current.editor =window.editormd("editor", {
          width: "100%",
          height: "90vh",
          // markdown: "xxxx",     // dynamic set Markdown text
          path: "/static/editor.md/lib/", // Autoload modules mode, codemirror, marked... dependents libs path
        });
      }
      editorRef.current.flag = true
    }

  }, []);

  useEffect(() => {
    const flag = contentImgRef.current.flag;

    if (!flag) {
      const editorContainer =
        document.getElementsByClassName("editorContainer")[0];
      if (editorContainer) {
        editorContainer.addEventListener("paste", (e) => {
          // 防止默认的粘贴事件和停止冒泡
          e.stopPropagation();

          const clipboardData = e.clipboardData;
          const files = clipboardData.files;

          if (files.length > 0) {
            const imageFile = files[0];

            if (imageFile.type && imageFile.type.indexOf("image", 0) != -1) {
              const reader = new FileReader();
              reader.onload = function (e) {
                const currentContentImg = e.target.result;
                // console.log("图像数据URL:", currentContentImg);
              };
              reader.readAsDataURL(imageFile);

              // 上传文章贴图
              apiContext(
                apiDict.chartlet,
                "POST",
                setContentImgDatas,
                setContentImgStatusCode,
                { content: imageFile }, // 注意content写法
                "form",
                {
                  next: window.location.pathname,
                  articleDatas: state ? state.articleDatas : undefined,
                },
                setMsgBoxShow,
                setMsgTips
              );
            }
          }
        });
      }
      contentImgRef.current.flag = true; // 保证粘贴事件监控仅一次
    }
  }, []);

  useEffect(() => {
    if (!contentImgDatas) {
      return;
    }
    const imgData = `![${contentImgDatas.id}](${getMediaUrl(
      contentImgDatas.content
    )})`;
    editorRef.current.editor.insertValue(imgData); // 插入图片链接
  }, [contentImgDatas]);

  useEffect(() => {
    if (!newCategotyDatas) {
      return;
    }

    if (newCategotyStatusCode === 401) {
      setMsgBoxShow(true);
      setMsgTips({ status: "warning", msg: "登录失效" });

      setTimeout(() => {
        navigate("/user/login/");
      }, 1000);
    } else if (newCategotyStatusCode === 201) {
      setMsgBoxShow(true);
      setMsgTips({ status: "success", msg: "分类创建成功" });

      apiContext(
        apiDict.category,
        "GET",
        setCategoryDatas,
        "",
        "",
        "",
        {
          next: window.location.pathname,
          articleDatas: state ? state.articleDatas : undefined,
        },
        setMsgBoxShow,
        setMsgTips
      );
    } else {
      setMsgBoxShow(true);
      setMsgTips({ status: "error", msg: "分类创建失败" });
    }
  }, [newCategotyDatas]);

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.ctrlKey && event.key === "s") {
        event.preventDefault();

        const articleAutoSave =
          document.getElementsByClassName("articleAutoSave")[0];
        articleAutoSave.click();
      }
    }

    // 添加事件监听器
    document.addEventListener("keydown", handleKeyDown);

    // 在 useEffect 的返回函数中移除事件监听器
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.ctrlKey && event.key === "l") {
        event.preventDefault();

        localStorage.removeItem("articleDatas");
        setMsgBoxShow(true);
        setMsgTips({ status: "info", msg: "文章历史已清空" });
        setFlushFlag(!flushFlag);
      }
    }

    // 添加事件监听器
    document.addEventListener("keydown", handleKeyDown);

    // 在 useEffect 的返回函数中移除事件监听器
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  useEffect(() => {
    const intervalTask = setInterval(() => {
      intervalSaveRef.current.flag = true;

      const articleAutoSave =
        document.getElementsByClassName("articleAutoSave")[0];
      articleAutoSave.click();
    }, 60000);

    return () => {
      clearInterval(intervalTask);
    };
  }, []);

  if (categoryDatas) {
    const categoryDict = {};
    categoryDatas.forEach((element) => {
      categoryDict[element.content] = {
        id: element.id,
        content: element.content,
      };
    });
    tagRef.current.categoryDict = categoryDict;
  }

  function handleMsgBoxClose() {
    setMsgBoxShow(false);
  }

  function labelHandleClick(v) {
    tagRef.current.article.categoryID = v.id;
    setAddCategoryID(v.id);
    setAddCategory(v);
  }

  function handleTitleChange(e) {
    tagRef.current.article.title = e.target.value;
  }

  function handleDescribeChange(e) {
    tagRef.current.article.description = e.target.value;
  }

  function handleTagChange(e) {
    const tags = e.target.value.split(",");
    tagRef.current.article.tags = [...tags];
  }

  function handleContentChange(e) {
    // tagRef.current.article.content = e.target.value;
    tagRef.current.article.content = textareaNode.value;
  }

  function handlePrivateChange(e) {
    tagRef.current.article.is_private = e.target.checked;
  }

  function handleSubmit() {
    const articleDataDict = tagRef.current.article;
    let articleDatas = {
      category_id: articleDataDict.categoryID,
      tags: articleDataDict.tags,
      title: articleDataDict.title,
      description: articleDataDict.description,
      // body: articleDataDict.content,
      body: textareaNode.value,
      is_private: articleDataDict.is_private ? true : false, // 默认false
    };

    backupInputArticleDatas.current.body = textareaNode.value;
    if (addCategory) {
      backupInputArticleDatas.current.category = addCategory;
    }
    backupInputArticleDatas.current.title = articleDataDict.title;
    backupInputArticleDatas.current.description = articleDataDict.description;
    backupInputArticleDatas.current.tags = articleDataDict.tags;
    backupInputArticleDatas.current.is_private = articleDataDict.is_private
      ? true
      : false;

    if (currentImgDatas) {
      articleDatas = { ...articleDatas, avatar_id: currentImgDatas.id };
      backupInputArticleDatas.current.avatar = currentImgDatas;
    } else if (articleDataDict.avatar_id) {
      articleDatas = { ...articleDatas, avatar_id: articleDataDict.avatar_id };
    }

    if (currentArticleUrl) {
      // PUT方法为修改旧文章, 防止提交时认证失效, 传递旧文章参数
      apiContext(
        currentArticleUrl,
        "PUT",
        setNewArticleDatas,
        setStatusCode,
        articleDatas,
        "",
        {
          next: window.location.pathname,
          articleDatas: state ? backupInputArticleDatas.current : undefined,
        },
        setMsgBoxShow,
        setMsgTips
      );
    } else {
      handleSaveLocal(false); // POST方法为新建文章,  防止提交时认证失效, 本地保存旧文章参数

      apiContext(
        apiDict.article,
        "POST",
        setNewArticleDatas,
        setStatusCode,
        articleDatas,
        "",
        {
          next: window.location.pathname,
          articleDatas: state ? state.articleDatas : undefined,
        },
        setMsgBoxShow,
        setMsgTips
      );
    }
  }

  function handleImgUpload() {
    const currentImg = imgRef.current.files[0];

    if (currentImg.type.indexOf("image", 0) === -1) {
      setMsgBoxShow(true);
      setMsgTips({ status: "warning", msg: "文件类型错误" });
      return;
    }

    if (currentImg) {
      apiContext(
        apiDict.articleAvatar,
        "POST",
        setCurrentImgDatas,
        setImgStatusCode,
        { content: currentImg }, // 注意content写法
        "form",
        {
          next: window.location.pathname,
          articleDatas: state ? state.articleDatas : undefined,
        },
        setMsgBoxShow,
        setMsgTips
      );

      const reader = new FileReader();
      reader.readAsDataURL(currentImg);
      reader.onload = function () {
        imgShowRef.current.src = reader.result;
      };
    }
  }

  function handleNewCategory() {
    apiContext(
      apiDict.category,
      "POST",
      setNewCategotyDatas,
      setNewCategotyStatusCode,
      { content: newCategoryRef.current.content }, // 注意content写法
      "",
      {
        next: window.location.pathname,
        articleDatas: state ? state.articleDatas : undefined,
      },
      setMsgBoxShow,
      setMsgTips
    );
    setDialogShow(false);
  }

  function handleSaveLocal(alertFlag = true) {
    const articleDataDict = tagRef.current.article;
    let articleDatas = {
      categoryID: articleDataDict.categoryID,
      tags: articleDataDict.tags,
      title: articleDataDict.title,
      description: articleDataDict.description,
      body: textareaNode.value,
      is_private: articleDataDict.is_private ? true : false,
    };
    if (currentImgDatas) {
      articleDatas = {
        ...articleDatas,
        avatar_id: currentImgDatas.id,
        avatar_content: currentImgDatas.content,
      };
    } else if (articleDataDict.avatar_id) {
      articleDatas = {
        ...articleDatas,
        avatar_id: articleDataDict.avatar_id,
        avatar_content: articleDataDict.avatar_content,
      };
    }

    localStorage.setItem("articleDatas", JSON.stringify(articleDatas));
    if (intervalSaveRef.current.flag) {
      intervalSaveRef.current.flag = false;
      return;
    }
    if (alertFlag) {
      setMsgBoxShow(true);
      setMsgTips({ status: "success", msg: "文章暂存" });
    }
  }

  return (
    <>
      <TopBarLayout />
      <Container
        maxWidth={false}
        sx={{
          marginTop: "30px",
          width: is_phone ? "100vw" : "80vw",
          height: "100vh", // 内容最大高度
        }}
        key={flushFlag}
      >
        <Grid container spacing={2} sx={{ minHeight: "200px" }}>
          <Grid
            item
            md={2.5}
            sx={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              minWidth: "200px",
            }}
          >
            <Card
              sx={{
                position: "relative",
                width: "100%",
                maxHeight: "300px",
              }}
              onClick={() => imgRef.current.click()}
            >
              <CardMedia
                component="img"
                src={
                  articleDatas && articleDatas.avatar
                    ? getMediaUrl(articleDatas.avatar.content)
                    : "/static/image/default1.jpg"
                }
                sx={{
                  cursor: "pointer",
                  height: "22vh",
                  minHeight: "100px",
                  bgcolor: "#ece6e6",
                }}
                ref={imgShowRef}
              />
              {(articleDatas && articleDatas.avatar) || currentImgDatas ? (
                <Box
                  sx={{
                    textAlign: "center",
                    position: "absolute",
                    bottom: "0",
                    left: "0",
                    cursor: "pointer",
                    width: "100%",
                    bgcolor: "#00000091",
                  }}
                >
                  <p
                    style={{
                      fontSize: "10px",
                      margin: "3px",
                      color: "white",
                    }}
                  >
                    当前标题图, 点击更换
                  </p>
                </Box>
              ) : (
                <Box
                  sx={{
                    textAlign: "center",
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    translate: "-50% -50%",
                    cursor: "pointer",
                    color: "#adadad",
                  }}
                >
                  <p style={{ fontSize: "45px", margin: "0" }}>+</p>
                  <p style={{ fontSize: "12px", margin: "3px" }}>上传标题图</p>
                </Box>
              )}
            </Card>
          </Grid>
          <Grid item md={4}>
            <Box sx={{ display: "flex", alignItems: "center", mt: "10px" }}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, fontSize: "15px", minWidth: "70px" }}
              >
                文章标题:
              </Typography>
              <Input
                label="文章标题"
                variant="outlined"
                sx={{
                  backgroundColor: "white",
                  ml: "20px",
                  fontSize: "13px",
                  width: "11vw",
                  minWidth: "200px",
                  minHeight: "30px",
                  ".MuiInputBase-input": {
                    padding: "0 5px 0 5px ",
                  },
                }}
                onChange={handleTitleChange}
                defaultValue={
                  articleDatas && articleDatas.title ? articleDatas.title : ""
                }
              />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mt: "10px" }}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, fontSize: "15px", minWidth: "70px" }}
              >
                文章标签:
              </Typography>
              <Input
                label="标签"
                variant="outlined"
                sx={{
                  backgroundColor: "white",
                  ml: "20px",
                  fontSize: "13px",
                  width: "11vw",
                  minWidth: "200px",
                  minHeight: "30px",
                  ".MuiInputBase-input": {
                    padding: "0 5px 0 5px ",
                  },
                }}
                onChange={handleTagChange}
                defaultValue={
                  articleDatas !== undefined &&
                  articleDatas.tags != undefined &&
                  Array.isArray(articleDatas.tags)
                    ? typeof articleDatas.tags[0] === "object" // 2025-09-05 14:16:56 兼容tags id数组和对象数组的情况
                      ? articleDatas.tags.map((v) => v.content).join(",")
                      : articleDatas.tags.join(",")
                    : ""
                }
              />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mt: "10px" }}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, fontSize: "15px", minWidth: "70px" }}
              >
                文章分类:
              </Typography>
              <Box sx={{ ml: "15px" }}>
                {tagRef.current.categoryDict
                  ? Object.values(tagRef.current.categoryDict).map((v, i) => {
                      return (
                        <Chip
                          label={v.content}
                          color={
                            addCategoryID === v.id ? "secondary" : "primary"
                          }
                          sx={{
                            ml: "3px",
                            cursor: "pointer",
                            fontSize: "12px",
                            height: "22px",
                          }}
                          key={i}
                          onClick={() => labelHandleClick(v)}
                        />
                      );
                    })
                  : ""}
                <IconButton
                  size="small"
                  color="secondary"
                  sx={{ ml: "3px" }}
                  onClick={() => setDialogShow(true)}
                >
                  <AddIcon fontSize="small" />
                </IconButton>
              </Box>
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mt: "10px" }}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, fontSize: "15px", minWidth: "70px" }}
              >
                文章描述:
              </Typography>
              <TextareaAutosize
                label="文章描述"
                variant="outlined"
                color="secondary"
                minRows={3}
                maxRows={4}
                style={{
                  backgroundColor: "white",
                  marginLeft: "20px",
                  fontSize: "13px",
                  width: "11.5vw",
                  borderRadius: "3px",
                  minWidth: "200px",
                }}
                onChange={handleDescribeChange}
                defaultValue={
                  articleDatas && articleDatas.description
                    ? articleDatas.description
                    : ""
                }
              />
            </Box>
            <Box sx={{ display: "flex", alignItems: "center", mt: "10px" }}>
              <Typography
                variant="body2"
                sx={{ fontWeight: 600, fontSize: "15px", minWidth: "70px" }}
              >
                私有文章:
              </Typography>
              <Checkbox
                style={{
                  marginLeft: "10px",
                }}
                defaultChecked={articleDatas ? articleDatas.is_private : false}
                onChange={handlePrivateChange}
              />
            </Box>
            <Box sx={{ display: "none", alignItems: "center", mt: "10px" }}>
              <Typography>标题图:</Typography>
              <input
                type={"file"}
                accept=".jpg, .jpeg, .png, .gif, .webp, .svg"
                style={{ marginLeft: "10px" }}
                ref={imgRef}
                onChange={handleImgUpload}
              />
            </Box>
          </Grid>
          <Grid
            item
            md
            sx={{
              alignItems: "flex-end",
              justifyContent: "flex-end",
              display: "flex",
            }}
          >
            <Button
              // disabled
              variant="contained"
              color="third"
              sx={{ mr: "10px", width: "5vw" }}
              size={is_phone ? "small" : "medium"}
              className="articleAutoSave"
              onClick={() => {
                articleSaveRef.current.flag = true;
                if (state) {
                  handleSubmit(); // 编辑旧文章提交
                } else {
                  handleSaveLocal(); // 编辑新文章暂存
                }
              }}
            >
              暂存
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                articleSaveRef.current.flag = false;
                handleSubmit();
              }}
              sx={{ width: "5vw" }}
              size={is_phone ? "small" : "medium"}
            >
              提交
            </Button>
          </Grid>
        </Grid>
        <Box sx={{ display: "flex", alignItems: "center", mt: "10px" }}>
          <div
            id="editor"
            className="editorContainer"
            // onKeyUp={handleContentChange}
            // onKeyDownCapture={handleContentChange}
          >
            <textarea
              style={{ display: "none" }}
              defaultValue={
                articleDatas && articleDatas.body ? articleDatas.body : ""
              }
            ></textarea>
          </div>
        </Box>
        <Toast
          open={msgBoxShow}
          onClose={handleMsgBoxClose}
          severity={msgTips.status}
          message={msgTips.msg}
        />
        <Dialog open={dialogShow}>
          <Box
            sx={{
              width: "20vw",
              minWidth: "250px",
              height: "15vh",
            }}
          >
            <Box
              sx={{
                mb: "15px",
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <IconButton
                size="small"
                sx={{ ml: "3px" }}
                onClick={() => setDialogShow(false)}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Input
                label="新文章分类"
                variant="outlined"
                sx={{
                  backgroundColor: "white",
                  mr: "20px",
                  fontSize: "13px",
                  width: "11vw",
                  minWidth: "130px",
                  ".MuiInput-input": {
                    textAlign: "center",
                  },
                }}
                onChange={(e) => {
                  newCategoryRef.current.content = e.target.value;
                }}
              />
              <Button
                variant="outlined"
                size="small"
                onClick={handleNewCategory}
              >
                新增
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Container>
    </>
  );
}
